const normalizeBaseUrl = (value) => {
  if (!value) {
    return "";
  }
  return value.replace(/\/+$/, "");
};

const getEnvironmentApiUrl = () => {
  return process.env.REACT_APP_API_BASE_URL || "";
};

export const API_BASE_URL = normalizeBaseUrl(getEnvironmentApiUrl());
